import { render, staticRenderFns } from "./ZonePills.vue?vue&type=template&id=4a013228&"
import script from "./ZonePills.vue?vue&type=script&lang=js&"
export * from "./ZonePills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports